import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Divider, Tag, Empty } from 'antd';
import { createUseStyles } from 'react-jss'

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { CollectionServer, JSXMap, POST, QueryParam, errorCatch, updateInArray } from 'fennec-ui'
import NovoeZasedanieRegionalnogoPravleniya from '../../forms/NovoeZasedanieRegionalnogoPravleniya'
import ZasedanieRegionalnogoPravleniya from '../../forms/ZasedanieRegionalnogoPravleniya'
import { DropdownAction } from 'fennec-ui'
import PageLayout from '../../components/PageLayout';
import { useLocaladminContext } from '../../../common/Context';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const useStyles = createUseStyles({
    modal: {
        '& .ant-modal-title': {
            marginRight: "25px"
        }
    },
    divider: {
        '&.ant-divider-horizontal.ant-divider-with-text-left': {
            fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
            fontSize: "13px",
            fontWeight: "400",
            color: "rgb(0, 0, 0)",
        },
        '&.ant-divider-horizontal.ant-divider-with-text-left .ant-divider-inner-text': {
            padding: "0px",
            marginRight: "10px",
        }
    },
    block: {
        '& .buttons': {
            marginBottom: "10px"
        },
        // '& .buttons .ant-btn': {
        //     border: "none",
        //     '-webkit-box-shadow': "none",
        //     'box-shadow': "none"
        // }
    },
    actionTitle: {
        marginBottom: "5px"
    }
})

export default function LocaladminGovernanceGeneral(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { auth } = props;
    const [loading, setLoading] = useState(false);
    const local = useLocaladminContext();

    const filters = () => [
        {
            label: "Дата",
            display: item => item.dataZasedaniya,
            name: "dataZasedaniya",
            type: "date",
            sort: true,
            filter: true,
            sorted: "DESC"
        },
        {
            label: "Номер протокола",
            display: item => item.nomerProtokolaZasedaniya,
            name: "nomerProtokolaZasedaniya",
            type: "string",
            sort: true,
            filter: true
        },
        {
            label: "Место проведения",
            display: item => item.mestoProvedeniyaZasedaniya.name,
            name: "mestoProvedeniyaZasedaniya",
            type: "string",
            sort: true,
            filter: true
        },
        {
            label: "Статус",
            display: item => item.tekushchiiStatusZasedaniya.opisanie,
            name: "tekushchiiStatusZasedaniya",
            type: "string",
            sort: true,
            filter: true
        },
    ];
    const badge = (record, index) => {
        if (record.tekushchiiStatusZasedaniyaID == 1) return (<Tag color={'blue'}>{record.tekushchiiStatusZasedaniya.opisanie}</Tag>);
        else if (record.tekushchiiStatusZasedaniyaID == 2) return (<Tag color={'geekblue'}>{record.tekushchiiStatusZasedaniya.opisanie}</Tag>);
        else if (record.tekushchiiStatusZasedaniyaID == 3) return (<Tag color={'green'}>{record.tekushchiiStatusZasedaniya.opisanie}</Tag>);
        else if (record.tekushchiiStatusZasedaniyaID == 4) return (<Tag color={'gold'}>{record.tekushchiiStatusZasedaniya.opisanie}</Tag>);
        else if (record.tekushchiiStatusZasedaniyaID == 5) return (<Tag>{record.tekushchiiStatusZasedaniya.opisanie}</Tag>);
        else return (<Tag>{record.tekushchiiStatusZasedaniya.opisanie}</Tag>);
    }
    return (
        <PageLayout>
            <div style={{ backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ padding: "10px" }}>
                    {local && <div>
                        <Divider type="horizontal" orientation="left">
                            Заседания регионального правления
                        </Divider>
                        <CollectionServer
                            name={"ZasedaniyaRegionalnogoPravleniya"}
                            auth={auth}
                            contextFilters={() => [
                                QueryParam("w-regionalnoeOtdelenie.ID", local?.ID)
                            ]}
                            filters={filters}
                            mode={"list"}
                            customRender={(items, {
                                collection,
                                setCollection,
                                setCollectionItem,
                                removeCollectionItem,
                                collectionActions,
                                modelActions,
                                update
                            }) => (<div>
                                {(items?.length <= 0) && <div><Empty description={"Нет данных"} style={{ padding: "40px 0px" }} /></div>}
                                {JSXMap(items, (item, idx) => {
                                    return (<div key={item.ID} className="item" style={{ display: "flex", justifyContent: "space-between", width: "100%", padding: "8px 0px" }}>
                                        <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                            <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
                                                <div style={{ display: "flex", justifyContent: "flex-start", gap:"5px" }}>
                                                    <div className='bg bg-grey' style={{ fontWeight: "600" }}>№{item.nomerProtokolaZasedaniya} </div>
                                                    <div>{dayjs(item.dataZasedaniya).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm')}</div>
                                                </div>
                                                <div style={{ color: "#7c7c7c", fontWeight: "400", fontSize: "12px" }}>
                                                    <span>Место проведения: {item.mestoProvedeniyaZasedaniya.name}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            {badge(item)}
                                        </div>
                                        {modelActions && <div onClick={(e) => { e.stopPropagation() }}>
                                            <DropdownAction
                                                style={{ padding: "0 8px 0 0" }}
                                                button={() => (<div className={`bg bg-grey pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                                    <i className="fa fa-ellipsis-h"></i>
                                                </div>)}
                                                items={modelActions(item, idx)?.map((e, idx) => ({
                                                    key: e.key || idx,
                                                    auth: auth,
                                                    mode: "MenuItem",
                                                    object: item,
                                                    collection: collection,
                                                    setCollection: setCollection,
                                                    ...e
                                                }))} />
                                        </div>}
                                    </div>)
                                })}
                            </div>)}
                            collectionActions={() => [
                                {
                                    object: local,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        POST(auth, `/api/novoezasedanieregionalnogopravleniya`, {...values, regionalnoeOtdelenieID: local?.ID},
                                            ({ data }) => {
                                                setCollection(updateInArray(collection, data, true));
                                                close();
                                            }, (err) => errorCatch(err, unlock)
                                        );
                                    },
                                    form: NovoeZasedanieRegionalnogoPravleniya,
                                    options: {
                                        initialValues: {
                                            regionalnoeOtdelenieID: local?.ID
                                        },
                                    },
                                    title: "Новое заседание",
                                    titles: {
                                        subheader: <div style={{ paddingBottom: "15px" }}>
                                            <div>Региональное отделение</div>
                                            <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                                                {local?.nazvanie}
                                            </div>
                                        </div>
                                    },
                                    modal: {
                                        width: "600px",
                                        title: "Новое заседание регионального правления",
                                    }
                                }
                            ]}
                            modelActions={(item) => [
                                {
                                    readonly: true,
                                    modal: { title: "Заседание регионального правления", width: "65%" },
                                    object: item,
                                    mode: "MenuItem",
                                    action: (values, unlock, close, { collection, setCollection }) => { },
                                    title: "Просмотр",
                                    form: ZasedanieRegionalnogoPravleniya
                                }
                            ]}
                        />
                    </div>}
                </div>
            </div>
        </PageLayout>
    );
}
